import { Organization } from 'gql/graphql';
import config from 'features/common/config/config';
import {
  Environments,
  EnvironmentFlags,
  organizationConditionsPerEnvironment,
} from './features';

type Condition = { name: string; parameters?: Record<string, string> };
type Data = { organization?: Organization };

type Params = {
  flagId: keyof EnvironmentFlags;
  condition: Condition;
  data?: Data;
};

const conditions = {
  MicrosoftTimeWindow: 'Microsoft.TimeWindow',
  PortalOrganizations: 'Portal.Organizations',
  PortalOrganizationsType: 'Portal.Organizations.Type',
};

const toUnixTime = (date: Date) => Math.floor(date.getTime() / 1000);

const checkIfEnabledOrganization = ({ flagId, data }: Params) => {
  const { id } = data?.organization ?? {};
  // Selected organisations from azure. No longer used
  // const selectedOrganizations = condition?.parameters ?? {};

  const env = config.toAzureFeatureLabel(
    window.location.hostname,
  ) as keyof Environments;
  const selectedOrganizations =
    organizationConditionsPerEnvironment?.[env]?.[flagId] ?? {};

  return id ? Object.hasOwn(selectedOrganizations, id) : false;
};

const checkIfValidTimeWindow = ({ condition }: Params) => {
  const start = toUnixTime(new Date(condition.parameters?.Start ?? ''));
  const end = toUnixTime(new Date(condition.parameters?.End ?? ''));
  const now = toUnixTime(new Date());

  if (!start) return now <= end;
  if (!end) return now >= start;
  return now >= start && now <= end;
};

const checkIfEnabledOrganizationType = ({ flagId, data }: Params) => {
  const orgType = data?.organization?.type;
  // Selected organisations from azure. No longer used
  // const conditionOrgType = condition.parameters?.type?.toUpperCase?.() as OrganizationType;

  const env = config.toAzureFeatureLabel(
    window.location.hostname,
  ) as keyof Environments;
  const conditionOrgType =
    (organizationConditionsPerEnvironment?.[env]?.[flagId]
      ?.orgTypeFilter as string[]) ?? [];
  if (!orgType || !conditionOrgType) return false;

  const normalizedOrgType = orgType.toUpperCase();
  return conditionOrgType.some(
    (allowedType) => allowedType.toUpperCase() === normalizedOrgType,
  );
};

const validationCallbackPerCondition = {
  [conditions.MicrosoftTimeWindow]: checkIfValidTimeWindow,
  [conditions.PortalOrganizations]: checkIfEnabledOrganization,
  [conditions.PortalOrganizationsType]: checkIfEnabledOrganizationType,
};

export { conditions, validationCallbackPerCondition };
